import React from "react"
import { useTranslation } from "react-i18next"

import { Select } from "components"
import classes from "./OfsDeliveryTypes.module.scss"

const OfsDeliveryTypes = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleChangeDeliveryType = (select) => {
    setForm(prev => ({
      ...prev,
      deliveryType: select?.value || ""
    }))
  }

  const options = [
    { label: t("ارسال_درب_منزل"), value: "delivery" },
    { label: t("بیرون_بر"), value: "SelfPickup" },
    { label: t("سالن"), value: "dineIn" }
  ]

  const value =
    options.find(o => o.value === form.deliveryType)

  return (
    <div className={classes["container"]}>
      <Select
        isClearable
        isSearchable={false}
        value={value}
        label={t("نوع_ارسال")}
        noOptionsMessage={() => null}
        options={options}
        onChange={handleChangeDeliveryType}
      />
    </div>
  )
}

export default OfsDeliveryTypes